module.exports = __webpack_public_path__ + "img/active-layer2.be612c72.png";